<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="dateString"
        readonly
        outlined
        style="width: 200px"
        v-bind="{...attrs,...$attrs}"
        v-on="{...on,...$listeners}"
      />
    </template>
    <v-date-picker
      v-model="dValue"
      no-title
      v-bind="{...$attrs}"
      scrollable
      :min="min"
      :max="max"
      @input="menu= false"
    />
  </v-menu>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      menu: false,
      dValue: this.value,
      dMin: null,
      dMax: null,
      timeData: null
    }
  },
  computed: {
    dateString () {
      if (!this.dValue) return ''
      // if same year, show only month and day
      if (moment(this.dValue).isSame(moment(), 'year')) {
        return moment(this.dValue).format('dddd, MMMM D')
      }
      return moment(this.dValue).format('dddd, MMMM D, YYYY')
    }
  },
  watch: {
    value: {
      handler (val) {
        if (!val) return
        const datetime = moment(val, 'YYYY-MM-DD HH:mm:ss', true)
        if (datetime.isValid()) {
          this.dValue = datetime.format('YYYY-MM-DD')
          this.timeData = datetime.format('HH:mm:ss')
        } else {
          this.dValue = val
          this.timeData = null
        }
      },
      immediate: true,
      deep: true
    },
    dValue: {
      handler (val) {
        if (!val) return
        if (this.timeData) {
          this.$emit('input', moment(val + ' ' + this.timeData).format('YYYY-MM-DD HH:mm:ss'))
        } else {
          this.$emit('input', moment(val).format('YYYY-MM-DD'))
        }
      },
      immediate: true,
      deep: true
    },
    min: {
      handler (val) {
        if (!val) return
        const datetime = moment(val, 'YYYY-MM-DD HH:mm:ss', true)
        if (datetime.isValid()) {
          this.dMin = datetime.format('YYYY-MM-DD')
        } else {
          this.dMin = val
        }
      },
      immediate: true,
      deep: true
    },
    max: {
      handler (val) {
        if (!val) return
        const datetime = moment(val, 'YYYY-MM-DD HH:mm:ss', true)
        if (datetime.isValid()) {
          this.dMax = datetime.format('YYYY-MM-DD')
        } else {
          this.dMax = val
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style>

</style>
